<template>
  <div class="data-reference-module">
    <div class="module-file-download">
      <div class="module-tip">
        <div class="title">{{ title }}</div>
        <template v-if="module.config && module.config.templateDownload">
          <action-form ref="downloadForm"
                       class="download-form"
                       :action="downloadTemplateUrl"
                       method="post"
                       target="_blank">
            <template v-if="module.uploadParams">
              <template v-for="(value, key) in module.uploadParams">
                <template v-if="Array.isArray(value)">
                  <input v-for="(val, index) in value"
                         :key="'upload-param-' + key + '-' + index"
                         type="hidden"
                         :name="key"
                         :value="val"/>
                </template>
                <input v-else
                       :key="'upload-param-' + key"
                       type="hidden"
                       :name="key"
                       :value="value"/>
              </template>
            </template>
            <el-button type="text" @click="downloadTemplateFile">
              <span>{{ downloadText }}</span>
            </el-button>
          </action-form>
        </template>
      </div>
      <div class="module-file">
        <div class="upload-wrap">
          <el-upload ref="dataReferenceModuleUpload"
                     :accept="supportFileType.length ? supportFileType.join(',') : ''"
                     :show-file-list="false"
                     :on-change="handleFileChange"
                     :before-upload="beforeFileUpload"
                     :on-progress="handleFileUploadProgress"
                     :on-success="handleFileUploadSuccess"
                     :on-error="handleFileUploadError"
                     name="uploadFile"
                     :http-request="options => httpRequest(options, true)"
                     :action="resolveFileUrl">
            <el-button type="primary"
                       plain>
              <span>上传文件</span>
            </el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <div v-if="module.uploadFile.uploading"
         class="module-handle">
      <el-progress :stroke-width="3"
                   :percentage="module.uploadFile.percent"
                   :show-text="false"></el-progress>
    </div>
    <slot name="result"
          v-bind="result"
          :msg="resultDataMsg"
          :delete="handleDeleteResult">
      <div v-if="result.data"
           class="module-result theme-border-hover">
        <div class="result-sta">
          <slot name="status"
                v-bind="result"
                :msg="resultDataMsg">
            <template v-if="result.errorLink">
              <i class="el-icon-warning is-warning"></i>
            </template>
            <template v-else>
              <i class="el-icon-success is-success"></i>
            </template>
            <span class="result">{{resultDataMsg}}</span>
          </slot>
          <template v-if="result.errorLink">
            <el-link class="err-link"
                     target="_blank"
                     type="danger"
                     :underline="false"
                     :href="$contextPath(result.errorLink)">
              <i class="el-icon-link"></i>
              <span>下载校验结果</span>
            </el-link>
          </template>
        </div>
        <div class="delete-btn">
          <el-button type="text"
                     icon="el-icon-delete"
                     @click="handleDeleteResult"></el-button>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import ElUpload from '../../mixins/upload/ElUpload'
export default {
  mixins: [ElUpload],
  name: 'DataReferenceModule',
  props: {
    value: {
      required: true
    },
    actionUrl: {
      required: true,
      type: String
    },
    title: {
      type: String,
      default: '请导入所需的数据文件'
    },
    downloadText: {
      type: String,
      default: '下载模板'
    },
    preHandleParams: {
      type: Function
    },
    extraParams: {
      type: Object,
      required: false
    },
    preHandleVerify: {
      type: Function
    }
  },
  data () {
    return {
      module: {
        uploadParams: null,
        loading: false,
        config: null,
        readyFile: null,
        uploadFile: {
          uploading: false,
          percent: 0,
          link: null,
          defaultMaxSize: 100 * 1024 * 1024
        }
      },
      result: {
        data: null,
        uploadCount: undefined,
        parserCount: undefined,
        errorLink: ''
      }
    }
  },
  computed: {
    downloadTemplateUrl: function () {
      return this.$contextPath(this.getActionUrl('Template'))
    },
    supportFileType: function () {
      let config = this.module.config
      if (config) {
        return config.supportFileType || []
      }
      return []
    },
    maxUploadFileSize: function () {
      let config = this.module.config
      if (config) {
        return config.maxFileSize || this.module.uploadFile.defaultMaxSize
      }
      return this.module.uploadFile.defaultMaxSize
    },
    resolveFileUrl: function () {
      let query = this.$qs.stringify(this.getActionParams(), {
        arrayFormat: 'repeat'
      })
      let resolveUrl = this.$contextPath(this.getActionUrl('Resolve'))
      if (query) {
        if (resolveUrl.includes('?')) {
          return resolveUrl + '&' + query
        } else {
          return resolveUrl + '?' + query
        }
      } else {
        return resolveUrl
      }
    },
    resultDataMsg () {
      let data = this.result.data
      if (data) {
        const parserCount = this.result.parserCount
        const uploadCount = this.result.uploadCount
        if (typeof parserCount === 'number') {
          if (typeof uploadCount === 'number') {
            return `总共上传${uploadCount}条数据，成功解析${parserCount}条数据`
          } else {
            return `成功解析${parserCount}条数据`
          }
        } else {
          if (Array.isArray(data)) {
            return `成功解析${data.length}条数据`
          } else {
            return '上传文件解析成功'
          }
        }
      }
    }
  },
  methods: {
    getActionUrl (action) {
      let actionUrl = this.actionUrl
      let quotIndex = actionUrl.indexOf('?')
      if (quotIndex > 0) {
        return `${actionUrl.substring(0, quotIndex)}${action}${actionUrl.substring(quotIndex)}`
      } else {
        return `${actionUrl}${action}`
      }
    },
    getActionParams () {
      if (this.preHandleParams) {
        return this.$extend(this.preHandleParams(), this.extraParams)
      } else {
        return this.extraParams || {}
      }
    },
    downloadTemplateFile () {
      let preHandleVerify = this.preHandleVerify
      if (preHandleVerify && !preHandleVerify()) {
        return
      }
      let downloadForm = this.$refs['downloadForm']
      if (downloadForm) {
        this.module.uploadParams = this.$extend(this.getActionParams(), this.$attrs)
        this.$nextTick(() => {
          downloadForm.submit()
        })
      }
    },
    // 校验文件
    validateFile (file, showMsg) {
      let filename = file.name
      let index = filename.lastIndexOf('.')
      if (index > 0) {
        let suffix = filename.substring(index).toLowerCase()
        if (!this.supportFileType.includes(suffix)) {
          if (showMsg) {
            this.$message.error('上传的文件格式不合法')
          }
          return false
        }
      } else {
        if (showMsg) {
          this.$message.error('上传的文件格式不合法')
        }
        return false
      }
      let isLt = file.size <= this.maxUploadFileSize
      if (isLt) {
        return true
      } else {
        if (showMsg) {
          this.$message.error('上传的文件大小超过限制')
        }
        return false
      }
    },
    // 文件准备
    handleFileChange (file, fileList) {
      if (file.status === 'ready') {
        if (this.validateFile(file, true)) {
          this.module.readyFile = file
          let dataReferenceModuleUpload = this.$refs['dataReferenceModuleUpload']
          if (dataReferenceModuleUpload) {
            fileList.forEach(f => {
              if (f !== file) {
                dataReferenceModuleUpload.handleRemove(f)
              }
            })
          }
        } else {
          this.resetModuleData()
        }
      }
    },
    // 上传前验证
    beforeFileUpload (file) {
      let preHandleVerify = this.preHandleVerify
      if (preHandleVerify && !preHandleVerify()) {
        return false
      }
      if (this.validateFile(file, true)) {
        this.module.uploadFile.uploading = true
        this.module.uploadFile.percent = 0
        return true
      } else {
        return false
      }
    },
    // 上传进度
    handleFileUploadProgress (event) {
      this.module.uploadFile.percent = Math.round(event.percent)
    },
    // 上传成功
    handleFileUploadSuccess (res) {
      this.module.uploadFile.uploading = false
      if (res['responseCode'] === 'SUCCESS') {
        let result = res['result']
        if (result) {
          if (Array.isArray(result)) {
            Object.keys(this.result).forEach(key => {
              let getVal = this.result[key]
              if (typeof getVal === 'string') {
                this.result[key] = ''
              } else {
                this.result[key] = undefined
              }
            })
            this.result.data = result
          } else {
            Object.keys(this.result).forEach(key => {
              this.result[key] = result[key]
            })
          }
        } else {
          this.$message.error('返回结果为空')
        }
      } else {
        this.$message.error(res.message || '获取返回信息失败')
      }
    },
    // 上传错误
    handleFileUploadError () {
      this.module.uploadFile.uploading = false
      this.$message.error('文件上传失败')
      this.$nextTick(() => this.resetModuleData())
    },
    // 加载导入配置
    loadReferenceConfigData () {
      this.module.loading = true
      let params = this.$extend(this.getActionParams(), this.$attrs)
      this.$ajax({
        url: this.actionUrl,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.module.config = response.data['config']
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.module.loading = false
      })
    },
    // 删除引用结果
    handleDeleteResult () {
      Object.keys(this.result).forEach(key => {
        let getVal = this.result[key]
        if (typeof getVal === 'string') {
          this.result[key] = ''
        } else {
          this.result[key] = undefined
        }
      })
      this.$nextTick(() => this.resetModuleData())
    },
    // 重置module数据
    resetModuleData () {
      this.module.readyFile = null
      this.module.uploadFile.link = null
      let dataReferenceModuleUpload = this.$refs['dataReferenceModuleUpload']
      if (dataReferenceModuleUpload) {
        dataReferenceModuleUpload.clearFiles()
      }
    }
  },
  mounted () {
    this.loadReferenceConfigData()
  },
  watch: {
    value: {
      handler: function (val) {
        this.result.data = val
      },
      immediate: true
    },
    'result.data': function (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss">
  @use "../../styles/color" as *;
  .data-reference-module {
    & > .module-file-download {
      flex: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff3e9;
      border: 1px solid #fdd5b0;
      padding: 16px 20px;
      & > .module-tip {
        & > .title {
          color: #e17655;
          font-size: 14px;
          font-weight: bold;
        }
        .download-form {
          margin-bottom: -6px;
          .el-button {
            color: #909399;
            &:hover {
              color: #606266;
            }
          }
        }
      }
      & > .module-file {
        margin-left: 18px;
        color: #909399;
        .upload-wrap {
          .el-button {
            padding: 7px 16px;
            border-radius: 0;
          }
        }
      }
    }
    & > .module-handle {
      .el-progress-bar {
        .el-progress-bar__outer {
          border-radius: 0;
          .el-progress-bar__inner{
            border-radius: 0;
          }
        }
      }
    }
    & > .module-result {
      margin-top: 10px;
      border: 1px dashed #d9d9d9;
      display: flex;
      align-items: stretch;
      & > .result-sta {
        flex: auto;
        font-size: 12px;
        line-height: 160%;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        & > .result {
          margin-left: 5px;
          flex: auto;
          color: #606266;
        }
        &>.err-link {
          margin-left: 5px;
          flex: none;
          font-size: 12px;
          span {
            margin-left: 2px;
          }
        }
        i {
          font-size: 14px;
        }
      }
      & > .delete-btn {
        flex: none;
        width: 45px;
        position: relative;
        .el-button {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          padding: 0;
          color: $set-danger-color;
        }
      }
      .is-success {
        color: $set-success-color;
      }
      .is-warning {
        color: $set-warning-color;
      }
    }
  }
</style>
